export default __webpack_public_path__ + "static/media/logo.ff1d50f2.png";